import React from "react";
import { Link } from "react-router-dom";
import { useMatch, useLocation } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { getAppFromPathname, getAppPrefix } from "../../../common/app";
import routing from "../../routing";

import { StyledFotter, FooterItem, FooterSpring, FixedBottomBlock } from "./styles";
import messages from "./messages";

const Footer = () => {
    const location = useLocation();
    const isPack = useMatch(`/${routing.pack}/:id/*`);
    const isPlan = useMatch(`/${routing.plan}/:id/*`);
    const isPublicPlan = useMatch(`/${routing.publicPlan}/:id/*`);
    const showFixedBottom = Boolean(isPack || isPlan || isPublicPlan);
    const app = getAppFromPathname(location.pathname);
    const prefix = getAppPrefix(app);
    if (location.pathname.includes(routing.practice)) return null;
    return (
        <StyledFotter>
            <FooterSpring>
                <FooterItem>
                    <Link to={prefix + "/" + routing.contact}>
                        <FormattedMessage {...messages.contact} />
                    </Link>
                </FooterItem>
                <FooterItem>
                    <Link to={prefix + "/" + routing.terms}>
                        <FormattedMessage {...messages.terms} />
                    </Link>
                </FooterItem>
                <FooterItem>
                    <Link to={prefix + "/" + routing.privacy}>
                        <FormattedMessage {...messages.privacy} />
                    </Link>
                </FooterItem>
                <FooterItem>
                    <FormattedMessage {...messages.copyright} values={{ year: 2026 }} />
                </FooterItem>
            </FooterSpring>
            {showFixedBottom && <FixedBottomBlock />}
        </StyledFotter>
    );
};

export default Footer;
